import { Transacao } from './transacao.model'
import { Agrupamento } from './agrupamento.model'

export class Detalhe<T extends Transacao> {
    transacao: T
    agrupamentos: Agrupamento<T>[]
}



// WEBPACK FOOTER //
// ./src/app/pkw-data/collect/extrato/detalhe.model.ts